import React from "react";
import { Descriptions } from "antd";

/**
 * Same multi-line Address string as customer checkout (fullAddress), from stored ShippingAddress.
 */
export function resolveDeliveryDetailsFromShippingAddress(s) {
  if (!s || typeof s !== "object") return null;
  const line1 = s.AddressLine1 ?? s.addressLine1 ?? s.line1 ?? "";
  const line2 = s.AddressLine2 ?? s.addressLine2 ?? s.line2 ?? "";
  const city = s.City ?? s.city ?? "";
  const state = s.State ?? s.state ?? "";
  const countryRaw = s.Country ?? s.country ?? "";
  const country = countryRaw || "India";
  const zip = s.Zip ?? s.zip ?? "";
  const displayName = s.Name ?? s.name ?? "";
  const contact = s.Contact ?? s.contact ?? "";
  const email = s.Email ?? s.email ?? "";

  const fullAddress = [
    line1,
    line2,
    [city, state].filter(Boolean).join(", "),
    zip ? `${country} - ${zip}` : country,
  ]
    .filter(Boolean)
    .join("\n");

  const hasAny = [displayName, contact, email, line1, line2, city, state, zip, countryRaw].some(
    (v) => v != null && String(v).trim() !== ""
  );
  if (!hasAny) return null;

  return { displayName, contact, email, fullAddress };
}

/**
 * Delivery details block: Name, Contact, Email, Address each on its own row.
 */
export function DeliveryDetails({ shippingAddress }) {
  const r = resolveDeliveryDetailsFromShippingAddress(shippingAddress);
  if (!r) {
    return (
      <span style={{ color: "#999" }}>No delivery details on this order</span>
    );
  }
  return (
    <Descriptions
      bordered
      column={1}
      size="small"
      items={[
        {
          key: "name",
          label: "Name",
          children: r.displayName || "—",
        },
        {
          key: "contact",
          label: "Contact",
          children: r.contact || "—",
        },
        {
          key: "email",
          label: "Email",
          children: r.email || "—",
        },
        {
          key: "address",
          label: "Address",
          children: (
            <span style={{ whiteSpace: "pre-line" }}>{r.fullAddress || "—"}</span>
          ),
        },
      ]}
    />
  );
}
